import React, {
  Component
} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
const clients = require('../assets/clientImages').default;
import {
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  Message,
  Label,
  Segment
} from 'semantic-ui-react';
const images = {
  home: require('../assets/img/HOME.jpg'),
  desarrollo: require('../assets/img/desarrollo.jpg'),
  court: require('../assets/img/court.jpeg'),
  empresa: require('../assets/img/empresa2.png'),
  clouds:require('../assets/img/clouds.jpg'),
  walking: require('../assets/img/walking.jpg')
}

const coverStyle = {
  backgroundColor: '#F4BE37',
  backgroundImage: `url(${images.walking})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  backgroundPositionY: '110vh',
  backgroundPositionX: 'right'
};
const mainSegmentStyle = {
  
  
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',
  fontSize: '30pt'
};
const textStyle = {
  fontSize: '16pt'
}

class HomeView extends Component {

  constructor (props) {
    super(props);
  }

  render () {
    return (

        <div style={coverStyle}>
        <Container fluid>
        <Segment size="massive" textAlign="center" basic className="coversegment">
            <Header as="h1" style={headerStyle}>
              
              <Header.Subheader style={subheaderStyle}>
                Simplificamos tu mundo
              </Header.Subheader>
              Sistel
            </Header>
          </Segment>
          <Segment basic style={{backgroundColor:'#f0b71d', marginBottom: 0}}>
          <Container>
            <Header  color="white" as="h2" textAlign="center" style={{color: 'white', fontSize: '5em'}}>
              Soluciones para empresas
              <Header.Subheader style={{fontSize: "0.5em"}}>
                Sin límites de escala, geografía o estructura
              </Header.Subheader>
            </Header>
          <Grid doubling padded stackable columns={2}>
            <Grid.Column>
                <Header icon color="white" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="group" color="white" />
                  Administración adecuada de recursos
                </Header>
                <Header icon color="white" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="thumbs up" color="white" />
                  Procesos de calidad
                </Header>
            </Grid.Column>
            <Grid.Column>
                <Header icon color="white" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="chart line" color="white" />
                  Mejores resultados
                </Header>
                <Header icon color="white" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="dollar" color="white" />
                  Control de costos
                </Header>
            </Grid.Column>
            
          </Grid>
          <Header as="h2" style={{fontSize: "2em", color: "rgba(0,0,0,0.5)"}}>Nuestros Clientes</Header>
              <Segment basic color="#f0b71d" style={{backgroundColor: '#f0b71d', marginTop:0, border:'0'}}>
                <div style={{transform:"skewX(10deg)"}}>
                {clients.slice(0,3).map(anImage => <Image style={{filter: "brightness(100)", transform: anImage.alt == "Parino"? "skewX(10deg)": undefined}} {...anImage} inline/>)}
                </div>
                <br/>
                <div style={{padding: 0, margin: 0, marginLeft: "-150px", marginRight: "-150px", transform: "skewX(10deg)", webkitMaskImage: "linear-gradient(to right, rgb(0,0,0,0), rgb(0,0,0,1) 20%, rgb(0,0,0,1) ,rgb(0,0,0,1) 80%, rgb(0,0,0,0))"}}>
                {clients.slice(3,1000).map(anImage => <Image size="small" style={{filter: "brightness(100)"}} {...anImage} inline/>)}
                </div>
                
              </Segment>
              </Container>
          </Segment>
          <div style={{margin: '5px', textAlign: "center", color: "white"}}><strong>Teniente Cundom 1574 - Corrientes - Argentina</strong></div>
          
        </Container>
        </div>
      
    );
  }
}

export default HomeView;



// WEBPACK FOOTER //
// ./client/containers/HomeView.js